import { render } from "./Clochettes.vue?vue&type=template&id=11fc9754&scoped=true"
import script from "./Clochettes.vue?vue&type=script&lang=js"
export * from "./Clochettes.vue?vue&type=script&lang=js"

import "./Clochettes.vue?vue&type=style&index=0&id=11fc9754&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11fc9754"]])

export default __exports__